import {
  DASHBOARD_DATAS_DOWNLOADED,
  DASHBOARD_DATAS_FAILED,
  DASHBOARD_DATAS_PENDING,
  DASHBOARD_DATAS_RESET, DASHBOARD_LATE_RENTS_DOWNLOADED,
} from './types';

export const INITIAL_STATE = {
  error: null,
  content: null,
  pending: false,
  sending: false,
  late_rent: null,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case DASHBOARD_DATAS_RESET:
      return INITIAL_STATE;
    case DASHBOARD_DATAS_PENDING:
      return {
        ...state,
        error: null,
        pending: true,
      };
    case DASHBOARD_DATAS_DOWNLOADED:
      return {
        ...state,
        error: null,
        pending: false,
        sending: false,
        content: action.payload,
      };
    case DASHBOARD_LATE_RENTS_DOWNLOADED:
      return {
        ...state,
        error: null,
        pending: false,
        sending: false,
        late_rents: action.payload,
      };
    case DASHBOARD_DATAS_FAILED:
      return {
        ...state,
        error: action.payload,
        pending: false,
        sending: false,
      };
    default:
      break;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/store/dashboardDatas/reducers.js